import type { HeroCarouselItemTextProps } from '../hero-carousel'
import { getCustomStyles } from '../utils'
import draftToHtml from 'draftjs-to-html'

interface DescriptionProps {
  description?: HeroCarouselItemTextProps
  textAlignment: CanvasTextAlign
}

export const Description = ({
  description,
  textAlignment,
}: DescriptionProps) => {
  const customStylesText = getCustomStyles(description?.styles)

  if (!description) {
    return <></>
  }

  return (
    <>
      {description?.text && (
        <div style={{ ...customStylesText, textAlign: textAlignment }}>
          <div
            style={{ minHeight: 'auto' }}
            className="text-[14px] sm:text-[16px] md:text-[16px] leading-[100%] m-0 pb-4 w-full md:h-auto"
            dangerouslySetInnerHTML={{
              __html: draftToHtml(JSON.parse(description?.text)),
            }}
          />
        </div>
      )}
    </>
  )
}

export default Description
